/**
 * Controller: membershipCategoriesCreateMapping
 */
angular.module('acme.view.application.membership.categories.create.mapping.controllers', [
    'acme.common.service.api',
    'acme.common.service.membership',
    'acme.common.factory.notice',
    'acme.common.service.validate',
    'acme.common.factory.gridState'
  ])
  .controller('MembershipCategoriesCreateMappingController', [ '$scope', '$timeout', '$filter', 'ApiService', 'MembershipService', 'NoticeFactory', 'ValidateService', 'GridStateFactory', function($scope, $timeout, $filter, ApiService, MembershipService, NoticeFactory, ValidateService, GridStateFactory) {

    $scope.primaryLink = '<div class="ui-grid-cell-contents"><a class="settings" data-ng-show="row.isSelected && !COL_FIELD" data-ng-click="grid.appScope.makePrimary($event, row, row.entity.id)" role="button">Make Primary</a><span data-ng-if="row.isSelected && COL_FIELD">{{ (COL_FIELD || 0) }}</span></div>';

    $scope.membershipCategoriesCreateMapping = {

      model: [],
      filtered: [],
      selectedRows: {},
      memberships: [],
      category: {},
      searchQuery: '',
      isLoaded: false,
      isSubmitted: false,

      validators: [],

      gridState: new GridStateFactory(),

      grid: {
        showFooter: false,
        multiselect: true,
        pageSize: 50,
        paginate: false,
        columns: [
          {
            field: 'id',
            displayName: 'ID',
            visible: false
          },
          {
            field: 'program',
            displayName: 'Program',
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'category',
            displayName: 'Category'
          },
          {
            field: 'subcategory',
            displayName: 'Sub-category'
          },
          {
            field: 'membershipCategoryName',
            name: 'primaryLink',
            displayName: 'Primary',
            cellClass: function(grid, row) {
              var r = '';
              if ($scope.membershipCategoriesCreateMapping.category.defaultType && row.entity.id === $scope.membershipCategoriesCreateMapping.category.defaultType.id) {
                r = 'settings-active';
              }
              return r;
            },
            cellTemplate: $scope.primaryLink
          }
        ]
      },

      primaryMappingDetails: {
        columns: 3,
        data: 'membershipCategoriesCreateMapping.category.defaultType',
        include: [
          'program',
          'category',
          'subcategory'
        ]
      },

      notice: new NoticeFactory(),

      init: function() {
        $scope.$on('MembershipService::Update', this.onMembershipServiceUpdate);
        $scope.$on('MembershipCategoriesCreate::Update', this.onMembershipCategoryCreateUpdate);
        $scope.$on('MembershipCategoriesCreate::Save', this.onMembershipCategoryCreateSave);

        this.initMapping();

        this.gridState.updateGridState();

        this.getMemberships();

        this.validators = [
          {
            field: 'membership-categories-create-mapping-primary',
            greater: {
              message: 'Please select a primary mapping',
              test: function() {
                return {
                  less: ($scope.membershipCategoriesCreateMapping.category.defaultType) ? 0 : 1,
                  greater: 1,
                  equalTo: false
                };
              }
            }
          }];

        ValidateService.addFieldTests(this.validators);
      },

      initMapping: function() {
        var self = $scope.membershipCategoriesCreateMapping;
        self.category = MembershipService.getModel();
        self.model = MembershipService.getMembershipMapping();
      },

      getMemberships: function() {
        ApiService.membership.types.list(this.gridState.getGridState()).then(this.success.getMemberships, this.error.getMemberships);
      },

      selectMemberships: function() {
        var i, ii,
          j, jj,
          selected = [];


        for (i=0,ii=this.model.length;i<ii;i++) {
          if (this.memberships instanceof Array) {
            for (j = 0, jj = this.memberships.length; j < jj; j++) {
              if (this.model[i].id === this.memberships[j].id) {
                selected.push(this.memberships[j]);
                break;
              }
            }
          }
        }

        console.log('selectMemberships', selected);

        $scope.$broadcast('DataGrid::SetSelection', selected);
      },

      isValid: function(field) {
        var r = true;

        if (this.isSubmitted) {
          r = ValidateService.check(this.validators, field);
        }
        return r;
      },

      getErrors: function(fieldName) {
        return ValidateService.getError(fieldName);
      },

      search: function() {
        this.filtered = $filter('filter')(this.memberships, function(membership) {
          var cat = membership.category || '',
            subcat = membership.subcategory || '', program = membership.program || '',
            value = (cat + subcat + program).toLowerCase();
          return (value.indexOf($scope.membershipCategoriesCreateMapping.searchQuery.toLowerCase()) !== -1 ? membership : null);
        });
      },

      findMembership: function(types, id) {
        var i, ii,
          r = false;

        for (i=0,ii=types.length;i<ii;i++) {
          if (types[i].id == id) {
            r = {
              index: i,
              type: types[i]
            };
            break;
          }
        }
        return r;
      },

      makePrimary: function(event, row, id) {
        var self = $scope.membershipCategoriesCreateMapping, selectedType;
        event.stopPropagation();
        console.log('MembershipCategoriesCreateMappingController:=>', row.entity, id);
        selectedType = self.findMembership(self.memberships, id);
        if (selectedType) {
          self.category.defaultType = selectedType.type;
        }
        $scope.$broadcast('DataGrid::DataChange', {type: 'column'});
      },

      save: function() {

        var self = $scope.membershipCategoriesCreateMapping, current, id;

        self.notice.hideErrorMessages();
        self.notice.hideSuccessMessages();

        self.model = [];

        for (id in self.selectedRows) {
          if (self.selectedRows.hasOwnProperty(id)) {
            if (self.selectedRows[id].selected) {
              current = self.findMembership(self.memberships, id);
              self.model.push({
                id: self.selectedRows[id].data.id,
                level: self.selectedRows[id].data.level || null,
                program: self.selectedRows[id].data.program || null,
                category: self.selectedRows[id].data.category || null,
                subcategory: self.selectedRows[id].data.subcategory || null
              });
            }
          }
        }

        if (self.model.length === 0) {
          self.category.defaultType = null;
        }

        MembershipService.setMembershipMapping(self.model, self.category.defaultType);

        $scope.$broadcast('DataGrid::DataChange', {type: 'column'});

        self.isSubmitted = true;
        ValidateService.validate(self.validators);
      },

      success: {
        init: function(response) {},
        getMemberships: function(response) {
          var self = $scope.membershipCategoriesCreateMapping;
          self.memberships = response.data.payload.list;

          self.search();

          self.isLoaded = true;

          //next tick
          $timeout( function(){
            self.selectMemberships();
          },0);
        }
      },

      error: {
        init: function(response) {},
        getMemberships: function(response) {}
      },

      onMembershipServiceUpdate: function(e, data) {
        //the parent model has changed
        $scope.membershipCategoriesCreateMapping.initMapping();
      },

      onMembershipCategoryCreateUpdate: function(e, data) {
        // a tab has changed
        var self = $scope.membershipCategoriesCreateMapping;

        if (data.view === 'mapping') {
          self.onMembershipServiceUpdate();

          // Next Tick
          $timeout(function () {
            self.getMemberships();
          }, 0);
        }
      },

      onMembershipCategoryCreateSave: function(e, data) {
        $scope.membershipCategoriesCreateMapping.save();
      },

      onDataGridSelectionChange: function(row, e) {
        var i, ii,
          self = $scope.membershipCategoriesCreateMapping;

        if (row instanceof Array) {
          for (i=0,ii=row.length;i<ii;i++) {
            self.selectedRows[row[i].entity.id] = { selected: row[i].isSelected, data: row[i].entity };
          }
        }else {
          if (!row.isSelected && self.category.defaultType && row.entity.id === self.category.defaultType.id) {
            //If primary mapping is deselected, set the default mapping to null.
            self.category.defaultType = null;
            $scope.$broadcast('DataGrid::DataChange', {type: 'column'});
          }
          self.selectedRows[row.entity.id] = { selected: row.isSelected, data: row.entity };
        }
      }

    };

    $scope.membershipCategoriesCreateMapping.init();

    $scope.gridOptions = {
      appScopeProvider: {
        makePrimary: $scope.membershipCategoriesCreateMapping.makePrimary
      }
    };

  }]);